// extracted by mini-css-extract-plugin
export default {"BaseLayoutContainer":"styles_BaseLayoutContainer__+9S-v","NoPadding":"styles_NoPadding__az+gK styles_BaseLayoutContainer__+9S-v"};